// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__2eWQS","header":"ReportDetails_header__13soj","title":"ReportDetails_title__1hgrj","left":"ReportDetails_left__d0Xn8"};